export enum NotificationChannel {
  PushNotification = 'PushNotification',
  Email = 'Email',
  Sms = 'Sms',
  WhatsApp = 'WhatsApp'
}

export enum NotificationCategory {
  OPERATION = 'OPERATION',
  RESERVATIONS = 'RESERVATIONS',
  TICKETS = 'TICKETS',
  PAYMENTS = 'PAYMENTS',
  ACCOUNT = 'ACCOUNT',
  COMMUNICATIONS = 'COMMUNICATIONS'
}

export interface INotificationPreference {
  event: string
  category: NotificationCategory
  mandatory: boolean
  availableChannels: NotificationChannel[]
  mutedChannels: NotificationChannel[]
}
